"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    root: {
        marginRight: '-0.5em',
        marginBottom: '-0.5em',
        '& > *': {
            marginRight: '0.5em',
            marginBottom: '0.5em'
        }
    }
});
//# sourceMappingURL=styles.js.map